<ng-container [formGroup]="formGroup">
  <dsd-fieldset>
    <h3 slot="legend" class="dsd-t-4" id="assurances" tabindex="-1">
      {{ 'modifierAdresse.questionnaireDGAG.titre' | translate }}
    </h3>
    <p slot="description" class="dsd-mb-sm">
      {{
        'modifierAdresse.questionnaireDGAG.description.' +
          (hasDetention ? 'avecDetention' : 'sansDetention') | translate
      }}
    </p>
    @if (!hasDetention) {
      <dsd-radio-group
        name="detention"
        required="true"
        class="dsd-mb-sm"
        identifier="detention"
        (dsdRadioGroupChange)="detentionChange($event)"
      >
        <span slot="legend">{{
          'modifierAdresse.questionnaireDGAG.detention.question' | translate
        }}</span>
        <span slot="error">{{
          'modifierAdresse.questionnaireDGAG.erreurSelection' | translate
        }}</span>

        <dsd-radio
          name="detientOui"
          value="true"
          formControlName="detientAssurances"
          (dsdRadioChange)="ajouterQuestionChangementFait()"
          >{{ 'modifierAdresse.questionnaireDGAG.detention.oui' | translate }}
        </dsd-radio>
        <dsd-radio
          name="detientNon"
          value="false"
          formControlName="detientAssurances"
          (dsdRadioChange)="retirerQuestionsChangementFaitEtMoins()"
          >{{ 'modifierAdresse.questionnaireDGAG.detention.non' | translate }}
        </dsd-radio>
      </dsd-radio-group>
    }

    @if (afficherQuestionChangementFait) {
      <dsd-radio-group
        name="changementFait"
        required="true"
        class="dsd-mb-sm"
        identifier="changementFait"
        (dsdRadioGroupChange)="changementFaitChange($event)"
      >
        <span slot="legend">{{
          'modifierAdresse.questionnaireDGAG.changementFait.question' | translate
        }}</span>
        <span slot="error">{{
          'modifierAdresse.questionnaireDGAG.erreurSelection' | translate
        }}</span>

        <dsd-radio
          name="changementFaitOui"
          value="true"
          formControlName="changementAssurancesFait"
          (dsdRadioChange)="retirerQuestionPreferenceAppelEtMoins()"
          >{{ 'modifierAdresse.questionnaireDGAG.changementFait.oui' | translate }}
        </dsd-radio>
        <dsd-radio
          name="changementFaitNon"
          value="false"
          formControlName="changementAssurancesFait"
          (dsdRadioChange)="ajouterQuestionPreferenceAppel()"
          >{{ 'modifierAdresse.questionnaireDGAG.changementFait.non' | translate }}
        </dsd-radio>
      </dsd-radio-group>
    }
    @if (afficherQuestionPreferenceAppel) {
      <dsd-radio-group
        name="preferenceAppel"
        required="true"
        class="dsd-mb-sm"
        identifier="preferenceAppel"
        column="true"
        (dsdRadioGroupChange)="preferenceAppelChange($event)"
      >
        <span slot="legend">{{
          'modifierAdresse.questionnaireDGAG.preferenceAppel.question' | translate
        }}</span>
        <span slot="error">{{
          'modifierAdresse.questionnaireDGAG.erreurSelection' | translate
        }}</span>

        <dsd-radio
          name="appelOui"
          value="true"
          formControlName="preferenceAppelAssurances"
          (dsdRadioChange)="ajouterQuestionPreferenceMoment()"
          >{{ 'modifierAdresse.questionnaireDGAG.preferenceAppel.oui' | translate }}</dsd-radio
        >
        <dsd-radio
          name="appelNon"
          value="false"
          formControlName="preferenceAppelAssurances"
          (dsdRadioChange)="retirerQuestionPreferenceMoment()"
          >{{ 'modifierAdresse.questionnaireDGAG.preferenceAppel.non' | translate }}</dsd-radio
        >
      </dsd-radio-group>
    }
    @if (afficherQuestionPreferenceMoment) {
      <dsd-radio-group
        name="preferenceMoment"
        required="true"
        identifier="preferenceMoment"
        column="true"
        (dsdRadioGroupChange)="preferenceMomentChange($event)"
      >
        <span slot="legend">{{
          'modifierAdresse.questionnaireDGAG.preferenceMoment.question' | translate
        }}</span>
        <span slot="error">{{
          'modifierAdresse.questionnaireDGAG.erreurSelection' | translate
        }}</span>

        <dsd-radio name="momentAM" value="am" formControlName="preferenceMomentAssurances">{{
          'modifierAdresse.questionnaireDGAG.preferenceMoment.am' | translate
        }}</dsd-radio>
        <dsd-radio name="momentPM" value="pm" formControlName="preferenceMomentAssurances">{{
          'modifierAdresse.questionnaireDGAG.preferenceMoment.pm' | translate
        }}</dsd-radio>
        <dsd-radio name="momentSoir" value="soir" formControlName="preferenceMomentAssurances">{{
          'modifierAdresse.questionnaireDGAG.preferenceMoment.soir' | translate
        }}</dsd-radio>
        <dsd-radio name="momentAucun" value="aucun" formControlName="preferenceMomentAssurances">{{
          'modifierAdresse.questionnaireDGAG.preferenceMoment.aucun' | translate
        }}</dsd-radio>
      </dsd-radio-group>
    }
  </dsd-fieldset>
</ng-container>
